/**
 * `Organization.title` is `varchar(64)` and unique on the backend, but nothing
 * server-side validates against it before a value is on its way there:
 * `BillingAddress.company_name`, which the checkout endpoint does validate, is
 * `varchar(100)`. A company name between the two lengths is accepted at
 * checkout and then kills the Stripe webhook that creates the account, so the
 * customer pays and never receives credentials. Cap it at the real column
 * width everywhere a company name becomes an organisation title.
 */
export const ORGANIZATION_TITLE_MAX_LENGTH = 64
